var _excluded = ["children", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useRef } from "react";
import { node, func } from "prop-types";
import { MenuItem } from "#library/components/Menu/MenuItem";
import { Icon } from "#library/components/Icon/Icon";
import { DATA_SPACER } from "#library/constants/enums";
import IconArrowDown from "#library/assets/icons/jds_arrowDown.svg";
import { hideDropdownMenu, setTriggerButton, showDropdownMenu } from "#library/components/Dropdown/Dropdown.actions";
import { useDropdown } from "#library/components/Dropdown/components/Provider";
export var TriggerMenuItem = function TriggerMenuItem(props) {
  var children = props.children,
    onClick = props.onClick,
    restProps = _objectWithoutProperties(props, _excluded);
  var _useDropdown = useDropdown(),
    state = _useDropdown.state,
    dispatch = _useDropdown.dispatch;
  var triggerRef = useRef();
  useEffect(function () {
    var triggerButton = triggerRef.current;
    dispatch(setTriggerButton(triggerButton));
  }, [dispatch]);
  var toggleDropdownMenu = function toggleDropdownMenu(event) {
    if (state.isDropdownMenuVisible) {
      dispatch(hideDropdownMenu());
    } else {
      dispatch(showDropdownMenu());
    }
    if (onClick) {
      onClick(event, state);
    }
  };
  return /*#__PURE__*/React.createElement(MenuItem, _extends({
    "aria-expanded": state.isDropdownMenuVisible,
    "aria-haspopup": "true"
  }, restProps, {
    as: "button",
    onClick: toggleDropdownMenu,
    ref: triggerRef
  }), children, /*#__PURE__*/React.createElement(Icon, {
    xlinkHref: "#".concat(IconArrowDown.id),
    dataSpacer: DATA_SPACER.LEFT_50
  }));
};
TriggerMenuItem.propTypes = {
  children: node.isRequired,
  onClick: func
};